import { apiClient } from '@/lib/api/api-client'

import type { SavedView, ViewConfig } from '@scrambl/shared'

export interface ProjectTaskViewState {
  userViews: SavedView[]
  sharedViews: SavedView[]
  activeViewId?: string
  defaultViewId?: string
}
export type ProjectTaskViewCommand =
  | {
      action: 'save'
      scope: 'user' | 'organization'
      viewId: string
      name: string
      config: ViewConfig
    }
  | { action: 'delete'; scope: 'user' | 'organization'; viewId: string }
  | { action: 'select' | 'default'; viewId: string | null }

export const projectTaskViewsApi = {
  get(projectId: string, organizationId: string) {
    return apiClient<ProjectTaskViewState>(
      `/projects/${projectId}/task-views`,
      {
        skipOrgContext: true,
        headers: { 'x-organization-id': organizationId },
      },
    )
  },
  execute(
    projectId: string,
    organizationId: string,
    command: ProjectTaskViewCommand,
  ) {
    return apiClient<ProjectTaskViewState>(
      `/projects/${projectId}/task-views`,
      {
        method: 'PATCH',
        body: command,
        skipOrgContext: true,
        headers: { 'x-organization-id': organizationId },
      },
    )
  },
}
